import * as Yup from 'yup';

export const OtherIncomeUpdateFormSchema = () =>
  Yup.object({
    amount: Yup.number().default(0),
    description: Yup.string().default(''),
    transactionAt: Yup.date().default(new Date()),
    accountType: Yup.string().nullable().default(null),
    accountableId: Yup.string().nullable().default(null),
    acknowledgedAt: Yup.date().nullable().default(null),
  });

export const OtherIncomeDetailCreateFormSchema = () =>
  Yup.object({
    amount: Yup.number().default(0),
    description: Yup.string().default(''),
    transactionAt: Yup.date().default(new Date()),
    accountType: Yup.string().nullable().default(null),
    accountableId: Yup.string().nullable().default(null),
    acknowledgedAt: Yup.date().nullable().default(null),
  });

export const OtherIncomeCreateFormSchema = () =>
  Yup.object({
    incomableRefId: Yup.string().default(''),
    incomableRefType: Yup.string().default('Tour'),
    otherIncomes: Yup.array(OtherIncomeDetailCreateFormSchema()).default([]),
  });

export type OtherIncomeUpdateFormType = Yup.InferType<
  ReturnType<typeof OtherIncomeUpdateFormSchema>
>;

export type OtherIncomeDetailCreateFormType = Yup.InferType<
  ReturnType<typeof OtherIncomeDetailCreateFormSchema>
>;

export type OtherIncomeCreateFormType = Yup.InferType<
  ReturnType<typeof OtherIncomeCreateFormSchema>
>;
